var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "v-chart__legends",
      style: {
        paddingRight: _vm.showArrow ? `${_vm.offsetHeight}px` : "0",
        height: _vm.height,
      },
    },
    [
      _vm._l(_vm.legends, function (item) {
        return _c(
          "label",
          {
            key: item,
            staticClass: "legend",
            on: {
              click: function ($event) {
                $event.preventDefault()
                $event.stopPropagation()
                return _vm.change(item)
              },
            },
          },
          [
            _c("i", {
              class: _vm.legend,
              style: {
                background: _vm.hideLegends[item]
                  ? "#ddd"
                  : _vm.legendColor[item],
              },
            }),
            _c(
              "span",
              { style: { color: _vm.hideLegends[item] ? "#ddd" : "inherit" } },
              [_vm._v(_vm._s(item))]
            ),
          ]
        )
      }),
      _vm.showArrow
        ? _c(
            "label",
            {
              staticClass: "v-chart__legends__slide",
              on: { click: _vm.toogle },
            },
            [_c("i", { class: ["icon v-icon-up", { active: _vm.active }] })]
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }